import { Link } from "react-router-dom";
import { ArrowUpRight, FileText, ClipboardCheck, ListChecks } from "lucide-react";
import { useLang } from "@/i18n";
import { MaskedLines, Reveal, FadeIn, Kicker } from "@/components/motion";

const typeIcons = [ClipboardCheck, FileText, ListChecks];

export default function Resources() {
  const { t } = useLang();
  const r = t.resources;

  return (
    <>
      <section className="relative overflow-hidden pt-32 pb-16 sm:pt-40 sm:pb-20 grain" data-testid="resources-hero">
        <div className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full bg-gold-light/25 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <FadeIn delay={0.1}>
            <Kicker>{r.kicker}</Kicker>
          </FadeIn>
          <MaskedLines
            className="mt-9 max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-navy-900 sm:text-5xl lg:text-6xl"
            delay={0.25}
            lines={[r.title]}
          />
          <Reveal delay={0.6}>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-navy-900/70 sm:text-lg" data-testid="resources-intro">
              {r.intro}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 sm:pb-28" data-testid="resources-list">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid gap-px border border-navy-900/10 bg-navy-900/10 lg:grid-cols-3">
            {r.items.map((item, i) => {
              const Icon = typeIcons[i];
              return (
                <Reveal key={i} delay={i * 0.1} className="group relative flex flex-col bg-cream p-9 transition-colors duration-500 hover:bg-white">
                  <div className="flex items-start justify-between">
                    <Icon size={24} className="text-sage-700 transition-transform duration-500 group-hover:-translate-y-1" />
                    <span className="border border-gold/40 px-3 py-1 text-[10px] uppercase tracking-[0.18em] text-gold-deep" data-testid={`resource-badge-${i}`}>
                      {r.comingSoon}
                    </span>
                  </div>
                  <p className="mt-7 text-[11px] uppercase tracking-[0.22em] text-navy-900/45" data-testid={`resource-type-${i}`}>{item.type}</p>
                  <h2 className="mt-3 font-serif text-xl tracking-tight text-navy-900 sm:text-2xl" data-testid={`resource-title-${i}`}>
                    {item.title}
                  </h2>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-navy-900/60">{item.text}</p>
                </Reveal>
              );
            })}
          </div>
          <Reveal delay={0.25} className="mt-12 text-center">
            <Link
              to="/contatti"
              data-testid="resources-cta-link"
              className="group inline-flex items-center gap-2.5 bg-navy-900 px-8 py-4 text-sm font-medium tracking-wide text-cream transition-colors duration-300 hover:bg-sage-700"
            >
              {r.cta}
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
